var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',[_c('PageHeader',{attrs:{"items":_vm.items,"title":_vm.title}}),_c('div',{staticClass:"card p-4 radius-20"},[_c('Form',{ref:"createManager"}),_c('div',{staticClass:"col-md-12"},[_c('SubmitButton',{attrs:{"text":"Create Profile","processing":_vm.processing},on:{"clicked":_vm.submitUser}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }